// extracted by mini-css-extract-plugin
export default {"AboutContainer":"styles_AboutContainer__j5bJX","AboutContent":"styles_AboutContent__LhCbX","gifRocket":"styles_gifRocket__IBKjZ","SobreContainer":"styles_SobreContainer__JWtZX"};